import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import { useMediatorModalHandle } from '../utils/withModalHandle';
import { OPEN_LANDLORD_VERIFIED_MODAL } from '../utils/constants';

import Modal from '../Modal';
import ModalHeader from '../ModalHeader';
import ModalBody from '../ModalBody';

import { DSIcon } from '../../../base';

import ReducedLandlordInformation from '../ReducedLandlordInformation';

import styles from './LandlordVerifiedModal.module.scss';

const LandlordVerifiedModal = ({
  landlordInformation = null,
  landlordScoring = null
}) => {
  const { isModalOpen, handleModalClose } = useMediatorModalHandle({
    channel: OPEN_LANDLORD_VERIFIED_MODAL
  });

  const showReducedLandlordInfo =
    landlordInformation?.type && landlordInformation != null;

  return isModalOpen ? (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={handleModalClose}
      size="medium"
      className={styles['landlord-verified-modal']}
    >
      <ModalHeader
        className={styles['landlord-verified-modal__header']}
        onRequestClose={handleModalClose}
        label={
          <>
            <DSIcon name="verified" size="ml" />
            <br />
            {trans('landlord_verified.modal.title')}
          </>
        }
      />
      <ModalBody className={styles['landlord-verified-modal__body']}>
        <p>{trans('landlord_verified.modal.description')}</p>

        <div>
          <h5 className={styles['landlord-verified-modal__conditions-title']}>
            {trans('landlord_verified.modal.conditions1')}
          </h5>
          <ul className={styles['landlord-verified-modal__conditions-list']}>
            <li>{trans('landlord_verified.modal.conditions1.item1')}</li>
            <li>{trans('landlord_verified.modal.conditions1.item2')}</li>
            <li>{trans('landlord_verified.modal.conditions1.item3')}</li>
          </ul>
        </div>

        {showReducedLandlordInfo && (
          <ReducedLandlordInformation
            type={landlordInformation.type}
            joiningDate={landlordInformation.firstListingDate}
            listingsPublished={landlordInformation.listingsPublished}
            averageResponseTime={landlordInformation.averageResponseTime}
            languages={landlordInformation.languages}
            landlordScoring={landlordScoring}
          />
        )}
      </ModalBody>
    </Modal>
  ) : null;
};

LandlordVerifiedModal.propTypes = {
  landlordInformation: PropTypes.shape({
    type: PropTypes.string,
    firstListingDate: PropTypes.string,
    listingsPublished: PropTypes.number,
    averageResponseTime: PropTypes.string,
    languages: PropTypes.arrayOf(PropTypes.string)
  }),
  landlordScoring: PropTypes.shape({
    score: PropTypes.number,
    totalBookingsClosed: PropTypes.number
  })
};

export default LandlordVerifiedModal;
